import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Paging } from '@app/model/paging';
import { BusinessInfo } from '@app/model/business-info'
import { Observable, catchError, forkJoin, map, of } from 'rxjs';
import { BusinessExtraInfo } from '@app/model/business-extra-info';
import { BusinessSliderInfo } from '@app/model/business-slider-info';
import { BusinessMediaInfo } from '@app/model/business-media-info';
import { BusinessTimeInfo } from '@app/model/business-time-info';
import { Product } from '@app/model/product';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class BusinessDetailsService {

  API_BASE_PATH = environment.API_URL;

  constructor(
    private http: HttpClient,
  ) { }


  // Get all business profile info based API
  getAllBusinessInfo(paging: Paging): Observable<BusinessInfo[]> {
    return this.http.get<BusinessInfo[]>(`${this.API_BASE_PATH}business-info` + '?paging=' + paging);
  }
  
  // Get all business profile info based API
  getTop8BusinessInfo(): Observable<BusinessInfo[]> {
    return this.http.get<BusinessInfo[]>(`${this.API_BASE_PATH}business-top-info`);
  }

  // Get single profile info based API
  getBusinessInfoByUUId(UUID: any): Observable<BusinessInfo> {
    return this.http.get<BusinessInfo>(`${this.API_BASE_PATH}${UUID}/business-info`);
  }

  getSliderImageByUUId(UUID: any): Observable<BusinessSliderInfo> {
    return this.http.get<BusinessSliderInfo>(`${this.API_BASE_PATH}${UUID}/business-slider`);
  }

  getProfileBgImgByUUId(UUID: any) {
    return this.http.get(`${this.API_BASE_PATH}${UUID}/profile-bg/2`)
  }

  getProfileImgByUUId(UUID: any) {
    return this.http.get(`${this.API_BASE_PATH}${UUID}/profile-image/1`)
  }

  getMediaInfoByUUId(UUID: any): Observable<BusinessMediaInfo> {
    return this.http.get<BusinessMediaInfo>(`${this.API_BASE_PATH}${UUID}/business-social`);
  }

  getExtraProductInfoByUUId(UUID: any): Observable<BusinessExtraInfo> {
    return this.http.get<BusinessExtraInfo>(`${this.API_BASE_PATH}${UUID}/business-extra-info`);
  }

  getTimeInfoByUUId(UUID: any): Observable<BusinessTimeInfo> {
    return this.http.get<BusinessTimeInfo>(`${this.API_BASE_PATH}${UUID}/business-time`);
  }

  // Add single profile info based on below API i.e step 1 after register
  addBusinessInfoByUUId(token: any, UUID: any, businessInfo: BusinessInfo) {
    debugger
    return this.http.post(`${this.API_BASE_PATH}${UUID}/business-info`, businessInfo);
  }

  addSliderImageByUUId(UUID: any, formData: FormData) {
    return this.http.post(`${this.API_BASE_PATH}${UUID}/business-slider`, formData);
  }

  addProfileImgByUUId(UUID: string, formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.API_BASE_PATH}${UUID}/profile-image`, formData);
  }

  addProfileBgImgByUUId(UUID: any, formData: FormData) {
    return this.http.post(`${this.API_BASE_PATH}${UUID}/profile-bg`, formData);
  }

  addMediaInfoByUUId(UUID: any, formData: BusinessMediaInfo) {
    return this.http.post(`${this.API_BASE_PATH}${UUID}/business-social`, formData);
  }

  addExtraProductInfoByUUId(UUID: any, formData: FormData) {
    return this.http.post(`${this.API_BASE_PATH}${UUID}/business-extra-info`, formData);
  }

  addTimeInfoByUUId(UUID: any, formData: BusinessTimeInfo) {
    return this.http.post(`${this.API_BASE_PATH}${UUID}/business-time`, formData);
  }

  // Update Profile info based on below API
  updateBusinessInfoByUUId(UUId: any, businessInfo: BusinessInfo): Observable<BusinessInfo> {
    return this.http.patch<BusinessInfo>(`${this.API_BASE_PATH}${UUId}/business-info`, businessInfo);
  }

  updateSliderImageByUUId(UUId: any, businessSliderInfo: BusinessSliderInfo): Observable<BusinessSliderInfo> {
    return this.http.patch<BusinessSliderInfo>(`${this.API_BASE_PATH}${UUId}/business-slider`, businessSliderInfo);
  }

  updateMediaByUUId(UUId: any, businessMediaInfo: BusinessMediaInfo): Observable<BusinessMediaInfo> {
    return this.http.patch<BusinessMediaInfo>(`${this.API_BASE_PATH}${UUId}/business-social`, businessMediaInfo);
  }

  updateExtraImageByUUId(UUId: any, formData: FormData): Observable<BusinessExtraInfo> {
    return this.http.patch<BusinessExtraInfo>(`${this.API_BASE_PATH}${UUId}/business-extra-info`, formData);
  }

  updateTimeByUUId(UUId: any, businessTimeInfo: BusinessTimeInfo): Observable<BusinessTimeInfo> {
    return this.http.patch<BusinessTimeInfo>(`${this.API_BASE_PATH}${UUId}/business-time`, businessTimeInfo);
  }

  // Delete 
  deleteProfileBgImgByUUId_Id(UUID: any, id = 2) {
    return this.http.delete(`${this.API_BASE_PATH}${UUID}/profile-bg/${id}`)
  }

  deleteProfileImgByUUId_Id(UUID: any, id = 1) {
    return this.http.delete(`${this.API_BASE_PATH}${UUID}/profile-image/${id}`)
  }

  deleteSliderImageByUUID_Id(UUID: any, id: any) {
    return this.http.delete(`${this.API_BASE_PATH}${UUID}/business-slider/${id}`);
  }

  deleteExtraImageByUUID_Id(UUID: any, id: any) {
    return this.http.delete(`${this.API_BASE_PATH}${UUID}/business-extra-info/${id}`);
  }
  
  searchBusinessByNameId(name: any, category: any, paging:Paging): Observable<any> {
    return this.http.get<Product>(`${this.API_BASE_PATH}search-business/${name}/${category}` + '?paging=' + paging);
  } 
  
  searchByBusiness(name: any, location: any, category: any, paging:Paging): Observable<any> {
    return this.http.get<Product>(`${this.API_BASE_PATH}search-business/${name}/${location}/${category}` + '?paging=' + paging);
  } 

  searchBusinessByAny(any: any, paging:Paging): Observable<any> {
    return this.http.get<Product>(`${this.API_BASE_PATH}search-any/${encodeURIComponent(any)}` + '?paging=' + paging);
  } 

  resolveBusinessBySlug(slug: string): Observable<any> {
    const paging = new Paging();
    paging.itemsPerPage = 10;
    paging.pageNumber = 1;
    paging.pagination = 1;
    paging.isAllWords = true;
    const compactName = slug.replace(/-/g, '');
    const readableName = slug.replace(/-/g, ' ');
    return forkJoin([
      this.searchBusinessByAny(compactName, paging).pipe(catchError(() => of({ data: [] }))),
      this.searchBusinessByAny(readableName, paging).pipe(catchError(() => of({ data: [] }))),
      this.getAllBusinessInfo(paging).pipe(catchError(() => of({ data: [] })))
    ]).pipe(
      map((results: any[]) => ({
        data: results.flatMap(result => Array.isArray(result) ? result : result?.data || [])
      }))
    );
  }
  
  searchByCategory(categoryName: any, paging:Paging): Observable<any> {
    return this.http.get<Product>(`${this.API_BASE_PATH}search-category/${categoryName}` + '?paging=' + paging);
  } 
  
  filterBusiness(paging:Paging, filterCriteria: any): Observable<any> {
    return this.http.get<BusinessInfo>(`${this.API_BASE_PATH}filter-business/${filterCriteria.name}/${filterCriteria.category}/${filterCriteria.subCategory}/${filterCriteria.country}/${filterCriteria.state}/${filterCriteria.district}` +'?paging=' + paging);
  }
}
